"use strict";

var cov_jtjq8363z = function () {
  var path = "/Volumes/GithubWorkspace/gitea-react-toolkit/src/components/repository/index.js";
  var hash = "3ac7617885689f7115f7b27c907e5f512bcc2e6b";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/Volumes/GithubWorkspace/gitea-react-toolkit/src/components/repository/index.js",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "3ac7617885689f7115f7b27c907e5f512bcc2e6b"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  Repository: true,
  withRepository: true
};
Object.defineProperty(exports, "Repository", {
  enumerable: true,
  get: function get() {
    return _Repository.Repository;
  }
});
Object.defineProperty(exports, "withRepository", {
  enumerable: true,
  get: function get() {
    return _withRepository.withRepository;
  }
});

var _crud = require("./crud");

Object.keys(_crud).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _crud[key];
    }
  });
});

var _Repository = require("./Repository");

var _withRepository = require("./withRepository");